import app from '../../forum/app';
import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import Link from '../../common/components/Link';

/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class HeaderPrimary extends Component {
  view() {
    return <ul className="Header-controls">{listItems(this.items().toArray())}</ul>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();
    items.add('main', Link.component({
      className: 'HeaderRouteListItem is_active',
      href: "/",
      onclick: () => this.setActive('main'),
    }, '首页'), 10);
    items.add('findWork', Link.component({
      className: 'HeaderRouteListItem',
      onclick: () => { window.open("https://rencai.ph/plugin.php?id=fn_job&m=list&class=1"); },
    }, '找工作'), 9);
    items.add('findWorker', Link.component({
      className: 'HeaderRouteListItem',
      onclick: () => { window.open("https://rencai.ph/plugin.php?id=fn_job&m=list_resume"); },
    }, '找人才'), 8);
    items.add('findCompany', Link.component({
      className: 'HeaderRouteListItem',
      onclick: () => { window.open("https://rencai.ph/plugin.php?id=fn_job&m=list_company"); },
    }, '找公司'), 7);
    // items.add('news', Link.component({
    //   className: 'HeaderRouteListItem',
    //   onclick: () => { window.open("https://rencai.ph/plugin.php?id=fn_job&m=news"); },
    // }, '新闻'), 6);
    items.add('support', Link.component({
      className: 'HeaderRouteListItem',
      onclick: () => { window.open("https://rencai.ph/plugin.php?id=fn_job&m=contact_us"); },
    }, '联系我们'), 0);
    return items;
  }

  setActive(currentRoute) {
    const $menu = this.$();
    const $items = $menu.find('li');
    $items.find('a').removeClass('is_active');
    $menu.find('li.item-' + currentRoute).find('a').addClass('is_active');
  }
}
